export enum OrganizationStep {
  ORGANIZATION = 1,
  SUBSCRIPTION = 2,
  USERS = 3,
  DOMAIN = 4,
  ORGANIZATION_ADMIN = 5,
  LIBRARIES = 6,
  ACCESS_KEYS = 7,
}
